import ReactGA from "react-ga4";

declare global {
  interface Window {
    _uxa?: Array<unknown[]>;
  }
}

const CONTENTSQUARE_TAG_URL =
  "https://t.contentsquare.net/uxa/95967ae209c83.js";
const isProduction = process.env.NODE_ENV === "production";

export const initGA = () => {
  const trackingId = process.env.REACT_APP_GA_TRACKING_ID;
  if (trackingId) {
    ReactGA.initialize(trackingId);
  }
};

export const initContentsquare = () => {
  if (!isProduction) return;
  if (document.querySelector(`script[src="${CONTENTSQUARE_TAG_URL}"]`)) return;

  window._uxa = window._uxa || [];
  const script = document.createElement("script");
  script.async = true;
  script.src = CONTENTSQUARE_TAG_URL;
  document.head.appendChild(script);
};

export const logPageView = () => {
  const path = window.location.pathname + window.location.search;
  ReactGA.send({ hitType: "pageview", page: path });

  if (isProduction) {
    const { pathname, search, hash } = window.location;
    const hashSuffix = hash ? `${search ? "&" : "?"}__${hash.slice(1)}` : "";

    window._uxa = window._uxa || [];
    window._uxa.push(["trackPageview", `${pathname}${search}${hashSuffix}`]);
  }
};
